import { MultiSelect } from 'primeng/multiselect'

import { checkIsElementAttached } from '../../layout/utils'

export function patchMultiSelect() {
  /**
   * Patch the MultiSelect hide method to fix stale overlays due to custom route reuse
   *
   * PrimeNG overlays attach their content to a separate part of the DOM (outside the Angular component tree)
   * When using a custom route reuse strategy, the normal component destruction does not occur,
   * so the overlay may remain visible in the DOM even though its component is detached
   */
  const orig__MultiSelect_hide = MultiSelect.prototype.hide
  MultiSelect.prototype.hide = function (...args) {
    orig__MultiSelect_hide.call(this, ...args)

    setTimeout(() => {
      if (!checkIsElementAttached(this.el.nativeElement)) {
        this.cd.detectChanges()
      }
    }, 32)
  }
}

// Used to resolve unnecessary Android keyboard-open issue for primeng 20V
export const multiSelectPt: any = {
  hiddenInput: {
    inputmode: 'none',
    readonly: true,
  },
}
